import React from 'react';

import parse from 'html-react-parser';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import CommonTitle from '../../../common-components/common-title';
import CommonSmallText from '../../../common-components/common-small-text';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

let list1 = [
    {
        img: '/images/svg/converter/converter-blocks__point-img1.svg',
        number: '2 600',
        text: 'направлений конвертации',
    },
    {
        img: '/images/svg/converter/converter-blocks__point-img2.svg',
        number: '220',
        text: 'стран используют',
    },
    {
        img: '/images/svg/converter/converter-blocks__point-img3.svg',
        number: '231',
        text: 'формат поддерживает',
    },
];

let list2 = [
    {
        img: '/images/svg/converter/converter-blocks__point-img4.svg',
        number: 'ТОП-5',
        text: 'вошли в пятерку мировых сервисов конвертации',
    },
    {
        img: '/images/svg/converter/converter-blocks__point-img5.svg',
        number: '5 000 000',
        text: 'пользователей может выдержать эта платформа',
    },
    {
        img: '/images/svg/converter/converter-blocks__point-img6.svg',
        number: '1 500 000',
        text: 'посещений в месяц за 2 года, благодаря технологическому подходу в SEO',
    },
];

const Blocks = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
            <FullWrapper caseName="converter-blocks">
                <div className="converter-blocks__wrapper">
                    <div className="converter-blocks__item converter-blocks__cipher">
                        <CommonTitle className="converter-blocks__item-title">Цифры</CommonTitle>
                        {list1.map(({ img, number, text }, index) => (
                            <ScrollAnimation
                                animateIn="fadeIn"
                                offset={100}
                                animateOnce={true}
                                duration={1}
                                className="converter-blocks__point"
                                key={index}
                            >
                                <div className="converter-blocks__point-wrapper">
                                    <div className="converter-blocks__point-img">
                                        <img src={img} alt="" loading="lazy" />
                                    </div>
                                    <div className="converter-blocks__point-num">
                                        {parse(number)}
                                    </div>
                                </div>
                                <CommonSmallText className="converter-blocks__point-text">
                                    {parse(text)}
                                </CommonSmallText>
                            </ScrollAnimation>
                        ))}
                    </div>
                    <div className="converter-blocks__item converter-blocks__results">
                        <CommonTitle className="converter-blocks__item-title">
                            Результаты
                        </CommonTitle>
                        {list2.map(({ img, number, text }, index) => (
                            <ScrollAnimation
                                animateIn="fadeIn"
                                offset={100}
                                animateOnce={true}
                                duration={1}
                                className="converter-blocks__point"
                                key={index}
                            >
                                <div className="converter-blocks__point-wrapper">
                                    <div className="converter-blocks__point-img">
                                        <img src={img} alt="" loading="lazy" />
                                    </div>
                                    <div className="converter-blocks__point-num">
                                        {parse(number)}
                                    </div>
                                </div>
                                <CommonSmallText className="converter-blocks__point-text">
                                    {parse(text)}
                                </CommonSmallText>
                            </ScrollAnimation>
                        ))}
                    </div>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Blocks;
